import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
// @ts-ignore
import pdf from 'vue-pdf'
import { PDFViewState, initialPDFViewState } from '@/components/pdf-view/pdf-view.models'
import { b64toBlob } from '@/utils/binary'

@Component({
    components: {
        pdf
    }
})
export default class PdfView extends Vue {
    // pdf bytes - use atob function!
    @Prop() pdfB64!: string;
    @Prop() pdfFileName: string='anapath.pdf';
    state: PDFViewState

    constructor() {
        super()
        this.state = initialPDFViewState()
    }

    @Watch('pdfB64', { immediate: true })
    _onPDFB64Change():void {
        this.state.pdfData = { data: atob(this.pdfB64) }
        this.state.currentPage = 1
    }

    get _disabledPreviousPageButton(): boolean {
        return !(this.state.currentPage - 1)
    }

    get _disabledNextPageButton(): boolean {
        return this.state.currentPage + 1 > this.state.pageCount
    }

    _onNextPageClick():void {
        if (this.state.currentPage < this.state.pageCount) { this.state.currentPage++ }
    }

    _onPreviousPageClick(): void {
        if (this.state.currentPage > 1) { this.state.currentPage-- }
    }

    _onNumPagesLoaded(total: number): void {
        this.state.pageCount = total
    }

    _onPageInput(newPage: string): void {
        const min = 1
        const max = this.state.pageCount
        this.state.currentPage = Math.min(Math.max(parseInt(newPage), min), max)
    }

    _onDownloadClick(): void {
        const url = window.URL.createObjectURL(b64toBlob(this.pdfB64, 'application/pdf'))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.pdfFileName)
        document.body.appendChild(link)
        link.click()
    }
}
